__turbopack_context__.v({
  "additional": "HeroBannerInfo-module-scss-module__8F1p5G__additional",
  "main": "HeroBannerInfo-module-scss-module__8F1p5G__main",
  "main__button": "HeroBannerInfo-module-scss-module__8F1p5G__main__button",
  "main__content": "HeroBannerInfo-module-scss-module__8F1p5G__main__content",
  "main__image": "HeroBannerInfo-module-scss-module__8F1p5G__main__image",
  "main__info": "HeroBannerInfo-module-scss-module__8F1p5G__main__info",
  "root": "HeroBannerInfo-module-scss-module__8F1p5G__root",
  "title": "HeroBannerInfo-module-scss-module__8F1p5G__title",
});
